import * as React from 'react';
import { CONTROL_SIZE } from '@/components/ui/types/control-enums';

import { INPUT_APPEARANCE } from '../types/input-variants-enums';
import { Input } from '@/components/ui/input';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

export const SidebarInput = React.forwardRef<
  React.ElementRef<typeof Input>,
  React.ComponentProps<typeof Input>
>(({ className, ...props }, ref) => {
  return (
    <Input
      appearance={INPUT_APPEARANCE.DEFAULT}
      size={CONTROL_SIZE.COMPACT}
      ref={ref}
      data-sidebar="input"
      className={cn(
        'focus-visible:ring-focus-ring h-8 w-full bg-surface-base shadow-none focus-visible:ring-2',
        className
      )}
      {...props}
    />
  );
});
SidebarInput.displayName = 'SidebarInput';

export const SidebarSeparator = React.forwardRef<
  React.ElementRef<typeof Separator>,
  React.ComponentProps<typeof Separator>
>(({ className, ...props }, ref) => {
  return (
    <Separator
      ref={ref}
      data-sidebar="separator"
      className={cn('bg-sidebar-border mx-2 w-auto', className)}
      {...props}
    />
  );
});
SidebarSeparator.displayName = 'SidebarSeparator';
